import { c as _c } from "react-compiler-runtime";
import { useEffect, useState } from 'react';
import isEqual from 'hs-lodash/isEqual';
function createStableReference(object, keys) {
  return keys.reduce((acc, key) => {
    acc[key] = object[key];
    return acc;
  }, {});
}

/**
 * Ref: https://git.hubteam.com/HubSpot/Critsit/issues/4039
 *
 * Ensures stable references for all `keys` defined in `object`.
 * Useful for props that are sent by collaboration-sidebar consumers that could have unstable references,
 * causing collaboration-sidebar to re-render unnecessarily (Example: https://git.hubteam.com/HubSpotProtected/email-editor-ui/pull/514).
 */
export default function useStableReferences(t0) {
  "use memo";

  const $ = _c(10);
  const {
    object,
    keys
  } = t0;
  let t1;
  if ($[0] !== keys || $[1] !== object) {
    t1 = createStableReference(object, keys);
    $[0] = keys;
    $[1] = object;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [stableReferences, setStableReferences] = useState(t1);
  let t2;
  let t3;
  if ($[3] !== keys || $[4] !== object) {
    t2 = () => {
      const newValues = createStableReference(object, keys);
      setStableReferences(prev => isEqual(prev, newValues) ? prev : newValues);
    };
    t3 = [object, keys];
    $[3] = keys;
    $[4] = object;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== object || $[8] !== stableReferences) {
    t4 = Object.assign({}, object, stableReferences);
    $[7] = object;
    $[8] = stableReferences;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}